<!-- ════════════════════════════════════════════════
     VISION FOR UMMAH — ABOUT (HOME SECTION)
     ════════════════════════════════════════════════ -->
<section class="about-area" style="background: var(--cream-200);">
  <div class="container">
    <div class="row align-items-center">

      <!-- Image -->
      <div class="col-lg-6 col-md-12">
        <div class="about-image">
          <img [src]="createImgPath(aboutUsPages.img1)" alt="{{ aboutUsPages?.title }}">
        </div>
      </div>

      <!-- Text -->
      <div class="col-lg-6 col-md-12">
        <div class="about-content">
          <span class="sub-title">حولنا</span>
          <h2>{{ aboutUsPages?.title }}</h2>
          <p>{{ aboutUsPages?.shortText }}</p>
          <a routerLink="/about" class="btn btn-primary btn-lg">
            <i class='bx bx-right-arrow-alt'></i>
            {{"MENU.ReadAll" | translate}}
          </a>
        </div>
      </div>

    </div>
  </div>
</section>
